import * as React from 'react';
import WorkFlowEditorContainer from './Components/WorkFlowEditor/WorkFlowEditorContainer';
import CustomMenu from '../../components/CustomMenu/CustomMenu';

/**
 * ワークフロー編集ページ
 * - カスタムメニュー内にワークフローエディターコンテナを表示する
 */
export default function EditWorkFlow() {
 
  return (
   <CustomMenu>
          <WorkFlowEditorContainer/> 
    </CustomMenu>
       
    )}
    